import Icon from '@rio-cloud/rio-uikit/components/icon/Icon';
import { useIntl } from 'react-intl';

const NoMessageAlert = () => {
  const intl = useIntl();

  return (
    <div className="alert alert-dismissible alert-primary width-50pct">
      <div className="display-flex gap-10">
        <Icon className="text-color-primary text-size-h4" iconName="icon-info" />
        <div>
          <strong data-testid="empty-thread-message" className="text-size-16">
            {intl.formatMessage({ id: 'chatPage.chatThreadList.error.noMessage.title' })}
          </strong>
          <div className="margin-y-5">{intl.formatMessage({ id: 'chatPage.chatThreadList.error.noMessage' })}</div>
        </div>
      </div>
    </div>
  );
};

export default NoMessageAlert;
